import { activityLog_nameSpace } from "../constants/activityLog.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null,
};

export const downloadActivityLog = (state = initialState, action) => {
  switch (action.type) {
    case `DOWNLOADCSV_${activityLog_nameSpace}_REQUEST`:
      return {
        ...state,
        loading: true,
        request: action.request,
      };
    case `DOWNLOADCSV_${activityLog_nameSpace}_SUCCESS`:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null,
      };
    case `DOWNLOADCSV_${activityLog_nameSpace}_FAILURE`:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error,
      };
    case `DOWNLOADCSV_${activityLog_nameSpace}_RESET`:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};
